"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShadow = exports.decodeURI = exports.isStandalone = exports.getFlatListEmptyContentContainerStyle = exports.getRadius = exports.getFontSize = exports.getSpacing = void 0;
const react_native_1 = require("react-native");
const polished_1 = require("polished");
function getSpacing(space = 1) {
    if (space === 'border')
        return react_native_1.StyleSheet.hairlineWidth * 2;
    if (space === 'row')
        return 37;
    return space * 12;
}
exports.getSpacing = getSpacing;
function getFontSize(rem = 1) {
    return rem * 12;
}
exports.getFontSize = getFontSize;
function getRadius(raduis = 1) {
    return raduis * 8;
}
exports.getRadius = getRadius;
function getFlatListEmptyContentContainerStyle(data) {
    if (data && data.length !== 0)
        return { paddingVertical: getSpacing(0.5) };
    return { flex: 1 };
}
exports.getFlatListEmptyContentContainerStyle = getFlatListEmptyContentContainerStyle;
function isStandalone() {
    if (react_native_1.Platform.OS === 'web')
        return window.matchMedia('(display-mode: standalone)').matches;
    else
        return true;
}
exports.isStandalone = isStandalone;
function decodeURI(q) {
    return decodeURIComponent(decodeURIComponent(q));
}
exports.decodeURI = decodeURI;
function getShadow(props) {
    const { color = '#000000', opacity = 0.05, radius = 2, offsetWidth = 1, offsetHeight = 1, elevation = 2 } = props || {};
    const { blue, green, red } = polished_1.parseToRgb(color);
    return react_native_1.Platform.select({
        ios: {
            shadowColor: color,
            shadowOpacity: opacity,
            shadowRadius: radius,
            shadowOffset: {
                width: offsetWidth,
                height: offsetHeight,
            },
        },
        android: {
            elevation,
        },
        web: {
            boxShadow: `${offsetWidth}px ${offsetHeight}px 4px ${radius}px rgba(${red},${green},${blue},${opacity})`,
        },
    });
}
exports.getShadow = getShadow;
